"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessagesProvider = void 0;
const react_redux_1 = require("react-redux");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const useInterval_1 = require("../../hooks/useInterval");
const selectors_1 = require("../AccountProvider/selectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const DEFAULT_INTERVAL = 120000; // 1000 * 60 * 2
const useMessagesProvider = (interval = DEFAULT_INTERVAL) => {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.messagesProviderSaga });
    const user = (0, react_redux_1.useSelector)(selectors_1.selectAccountUser);
    const isAuthedUser = !!user;
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, useInterval_1.useInterval)(() => {
        dispatch(slice_1.messagesProviderActions.fetchCountNotifications());
    }, isAuthedUser ? interval : null, isAuthedUser);
};
exports.useMessagesProvider = useMessagesProvider;
//# sourceMappingURL=useMessagesProvider.js.map